"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const provider_components_1 = require("@kyruus/provider-components");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const utils_1 = require("../../lib/utils");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const Telehealth = ({ intl, provider, config, shouldSkipRender }) => {
    var _a;
    const isTelehealthIgnored = (((_a = config.provider_v9) === null || _a === void 0 ? void 0 : _a.summary_data) || []).find((s) => s.field === 'telehealth' &&
        Array.isArray(s.ignore) &&
        s.ignore.includes('true'));
    const skipRendering = !(0, provider_components_1.isVirtualProvider)(provider) ||
        !(0, utils_1.isSummaryDataConfigured)('telehealth', config) ||
        typeof provider.telehealth !== 'boolean' ||
        provider.telehealth === false ||
        isTelehealthIgnored;
    (0, react_1.useEffect)(() => {
        if (skipRendering) {
            // callback to the parent component to skip rendering
            shouldSkipRender('telehealth');
        }
    }, [skipRendering]);
    // do not render if data not present or if provider doesn't offer video visits
    if (skipRendering) {
        return null;
    }
    return (react_1.default.createElement(styles_1.ProviderInformationCard, { "data-testid": "info-card-telehealth" },
        react_1.default.createElement(styles_1.CardContentContainer, null,
            react_1.default.createElement(styles_1.CardContentHeader, null, intl.formatMessage(messages_1.default.telehealthHeader)),
            react_1.default.createElement(styles_1.CardContentText, null, intl.formatMessage(messages_1.default.telehealthText)))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(Telehealth));
//# sourceMappingURL=telehealth.js.map